import { Plus, Pencil, Trash2, Wallet } from "lucide-react";

const fmt = (n) => `₹${(n || 0).toLocaleString("en-IN")}`;

export const FinanceDrawings = ({ drawings, byPersonal, onAdd, onEdit, onDelete, isCeo }) => {
  const total = drawings.reduce((s, e) => s + (e.cheque_status === "bounced" ? 0 : e.amount), 0);
  const max = Math.max(...byPersonal.map((c) => c.amount), 1);

  return (
    <div className="space-y-5" data-testid="drawings-tab">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="bg-white border border-[#E5E7E5] rounded-md p-5 shadow-sm min-w-[220px]" data-testid="drawings-total-card">
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs uppercase tracking-wider text-[#5C6A63] font-semibold">Total Personal Drawings</p>
            <Wallet className="w-4 h-4 text-[#C5A059]" />
          </div>
          <p className="text-2xl font-bold text-[#8a6d33]" data-testid="drawings-total-value">{fmt(total)}</p>
          <p className="text-[11px] text-[#5C6A63] mt-1">kept separate from business profit</p>
        </div>
        <button onClick={onAdd} data-testid="add-drawing-btn"
          className="bg-[#0A3F2F] text-white text-sm font-semibold px-4 py-2.5 rounded-full flex items-center gap-2 hover:bg-[#0d5540]">
          <Plus className="w-4 h-4" /> Add Personal Drawing
        </button>
      </div>

      <div className="bg-white border border-[#E5E7E5] rounded-md p-5 shadow-sm">
        <h2 className="text-sm font-bold text-[#1C1C1C] mb-4">Breakdown by Category</h2>
        <div className="space-y-3" data-testid="drawings-breakdown">
          {byPersonal.length === 0 && <p className="text-sm text-[#5C6A63]" data-testid="no-drawings-breakdown">No personal drawings yet — categories will appear here.</p>}
          {byPersonal.map((c) => (
              <div key={c.category} data-testid={`drawing-cat-${c.category.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-[#5C6A63]">{c.category}</span>
                  <span className="font-semibold text-[#1C1C1C]">{fmt(c.amount)}</span>
                </div>
                <div className="h-2 bg-[#FAFAF8] rounded-full overflow-hidden">
                  <div className="h-full bg-[#C5A059] rounded-full" style={{ width: `${Math.max((c.amount / max) * 100, 4)}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

      <div className="bg-white border border-[#E5E7E5] rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E5E7E5] text-left text-xs uppercase tracking-wider text-[#5C6A63]">
              <th className="px-4 py-3 font-semibold">Date</th>
              <th className="px-4 py-3 font-semibold">Category</th>
              <th className="px-4 py-3 font-semibold">Description</th>
              <th className="px-4 py-3 font-semibold">Method / Source</th>
              <th className="px-4 py-3 font-semibold">Amount</th>
              <th className="px-4 py-3 font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody data-testid="drawings-table-body">
            {drawings.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-[#5C6A63]" data-testid="no-drawings">No personal drawings in this range.</td></tr>}
            {drawings.map((e) => (
              <tr key={e.id} className="border-b border-[#E5E7E5] last:border-0 hover:bg-[#FAFAF8]" data-testid={`drawing-row-${e.id}`}>
                <td className="px-4 py-3 whitespace-nowrap">{e.date}</td>
                <td className="px-4 py-3 font-semibold">{e.category}</td>
                <td className="px-4 py-3 text-[#5C6A63]">{e.description || "—"}</td>
                <td className="px-4 py-3 text-xs text-[#5C6A63]">{e.payment_method}{e.source_account ? ` · ${e.source_account}` : ""}</td>
                <td className="px-4 py-3 font-bold text-[#8a6d33]">{fmt(e.amount)}</td>
                <td className="px-4 py-3">
                  <div className="flex gap-3">
                    <button onClick={() => onEdit(e)} data-testid={`edit-drawing-${e.id}`} className="text-[#3D4A44] hover:text-[#0A3F2F]"><Pencil className="w-4 h-4" /></button>
                    {isCeo && (
                      <button onClick={() => onDelete(e.id)} data-testid={`delete-drawing-${e.id}`} className="text-[#3D4A44] hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
